import { DraftStepType } from '../../../insights.enums';
import { EditBehaviorDrawerParams } from '../../../insights.interface';
import { TemplateModel } from '../../../../bip-template/bip-template.interface';
import { QuestionItem } from '../../../../manage-settings/manage-settings.interface';

export enum WizardStepKind {
  BehaviorCategory = 'behavior-category',
  NativeField = 'native-field',
  EmbeddedCustomQuestion = 'embedded-custom-question',
  CustomQuestionBundle = 'custom-question-bundle',
  Summary = 'summary',
}

export interface ItemGating {
  isRequired: boolean;
  isHardStop: boolean;
  helpText: string;
}

export interface WizardStep {
  kind: WizardStepKind;
  refId: number;
  draftStepType: DraftStepType;
  label: string;
  helpText: string;
  isRequired: boolean;
  isHardStop: boolean;
  controlNames: string[];
  questionIds: number[];
  questionGating: Record<number, ItemGating>;
}

export interface WizardStepBuildInput {
  template: TemplateModel | null;
  templateCustomQuestions: QuestionItem[];
}

export interface NativeFieldDescriptor {
  lookupId: number;
  label: string;
  controlNames: string[];
}

export type DefineBehaviorWizardDrawerParams = EditBehaviorDrawerParams;
